import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { makeGetRequest } from "../../rest/RestService";
import { AuthorNameHelper } from "../../helper/AuthorNameHelper";
import { Link } from "react-router-dom";
import { sanitizeHTML } from "../../helper/SanitizeHTML";
const SubjectDetailBookBlock = ({
  subjectBooks,
  limit,
  totalCount,
  url,
  crumb,
}) => {
  const { code } = useSelector((state) => state.geolocation);
  const [books, setBooks] = useState([]);
  const [number, setNumber] = useState(limit);
  const query = new URLSearchParams(useLocation().search);
  const [load, setLoad] = useState("Load More");
  useEffect(() => {
    Array.isArray(subjectBooks) && setBooks([...subjectBooks]);
    setNumber(limit);
  }, [code, limit, subjectBooks]);
  const handleLoadMore = () => {
    setLoad("Loading...");
    const subject_slug = query.get("subject_slug");
    const series_slug = query.get("series_slug");
    const midUrl = series_slug
      ? `${subject_slug}/${series_slug}`
      : `${code}/${subject_slug}`;
    makeGetRequest(`${url}/${midUrl}/${number}`)
      .then((res) => {
        series_slug
          ? setBooks([...books, ...res.data.series_books])
          : setBooks([...books, ...res.data.subject_book]);
        setNumber(res.data.last_limit);
      })
      .finally(() => setLoad("Load More"));
  };
  return (
    <>
      <div
        className="col-xs-12 col-sm-12 col-md-9 col-lg-9"
        style={{ border: "solid green 0px" }}
      >
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 overall_refine_image">
          <div className="row load_subjects">
            {books.map((book, i) => (
              <div
                key={i}
                className="col-xs-6 col-sm-4 col-md-4 col-lg-4 book_container filter_book_"
                style={{
                  border: "0px solid red",
                  paddingTop: "10px",
                  height: "441px",
                }}
              >
                <div className="pull-left slider_img_shadow">
                  <Link
                    to={{
                      pathname: `/bookdetail`,
                      state: { crumb },
                      search: `?book_slug=${book?.book_slug}`,
                    }}
                  >
                    {book.img_path ? (
                      <img
                        className="book_cover_image"
                        src={book.img_path}
                        alt=""
                      />
                    ) : (
                      <div className="cover_no_image">No Image</div>
                    )}
                  </Link>
                </div>
                <div className="highlight_book_title_refine highlight_book_title">
                  <Link
                    to={{
                      pathname: `/bookdetail`,
                      state: { crumb },
                      search: `?book_slug=${book?.book_slug}`,
                    }}
                  >
                    {/*WEB-331 - fixing the title issue using dangerouslySetInnerHTML*/}
                    <span dangerouslySetInnerHTML={sanitizeHTML(book.title)} />
                  </Link>
                </div>
                <div className="new_author_container">
                  <div className="highlight_author_name_refine">
                    {AuthorNameHelper(book?.author_details)}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {books.length < totalCount ? (
            <div className="row load_more">
              <div
                style={{ border: "solid green 0px" }}
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              >
                <div
                  className="load_more_button load_subject"
                  rel={0}
                  onClick={handleLoadMore}
                >
                  <a href="abc" onClick={(e) => e.preventDefault()}>
                    {load}
                  </a>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default SubjectDetailBookBlock;
